import styled from '@emotion/styled';
import { grayScale } from 'app/colors';

export const LoadingMessageWrapper = styled.div`
  font-size: 1.4em;
  color: ${grayScale.dark};
`;
